export default __webpack_public_path__ + "static/media/img3.8ddff633.png";